module.exports = __webpack_public_path__ + "static/media/img03.17b26085.webp";